import moment from 'moment';
import cogoToast from 'cogo-toast';

import { EDITABLE_AFTER_LIVE, EDITABLE_DURING_ONBOARDING, STALLED_IN_PROGRESS_DAYS, STALLED_NOT_STARTED_DAYS } from './brandOnboardingFieldConfig';

export const STATUS_TABS = [
  { key: 'all', label: 'All', matches: () => true },
  { key: 'notStarted', label: 'Not Started', matches: code => getOnboardingStatusChip(code).className === 'notStarted' },
  { key: 'inProgress', label: 'In Progress', matches: code => getOnboardingStatusChip(code).className === 'inProgress' },
  { key: 'complete', label: 'Complete', matches: code => getOnboardingStatusChip(code).className === 'complete' },
  { key: 'needsAttention', label: 'Needs Attention', matches: code => isCodeStalled(code) }
];

export const getOnboardingStatusChip = registrationCode => {
  const onboardingStatus = registrationCode?.brand?.onboardingStatus;
  if (onboardingStatus === 'COMPLETE') return { label: 'Complete', className: 'complete' };
  if (onboardingStatus === 'IN_PROGRESS') return { label: 'In Progress', className: 'inProgress' };
  return { label: 'Not Started', className: 'notStarted' };
};

// null = unredeemed template, nothing restricted.
export const getEditableFieldNames = registrationCode => {
  if (!registrationCode?.isUsed) return null;
  const isLive = registrationCode.brand?.onboardingStatus === 'COMPLETE';
  return isLive ? EDITABLE_AFTER_LIVE : EDITABLE_DURING_ONBOARDING;
};

export const getLastActivityAt = registrationCode =>
  registrationCode.brand?.updatedAt || registrationCode.brand?.createdAt || registrationCode.createdAt;

export const isCodeStalled = registrationCode => {
  const statusChip = getOnboardingStatusChip(registrationCode);
  if (statusChip.className === 'notStarted') {
    return moment().diff(moment(registrationCode.createdAt), 'days') >= STALLED_NOT_STARTED_DAYS;
  }
  if (statusChip.className === 'inProgress') {
    return moment().diff(moment(getLastActivityAt(registrationCode)), 'days') >= STALLED_IN_PROGRESS_DAYS;
  }
  return false;
};

export const getStalledDetail = registrationCode => {
  const statusChip = getOnboardingStatusChip(registrationCode);
  if (statusChip.className === 'notStarted') {
    return `not started ${moment(registrationCode.createdAt).fromNow(true)} after the code was created`;
  }
  return `no onboarding activity in ${moment(getLastActivityAt(registrationCode)).fromNow(true)}`;
};

export const getOwnerInitials = name =>
  String(name)
    .split(' ')
    .map(part => part[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

// Hues stay on the cyan→pink arc so avatars never read as the page's status colors (emerald, amber, red).
export const getOwnerColorStyle = userId => {
  const hue = 170 + ((userId * 137.508) % 190);
  return { background: `hsl(${hue}, 60%, 88%)`, color: `hsl(${hue}, 45%, 30%)` };
};

export const copyToClipboard = text => {
  navigator.clipboard?.writeText(text).then(
    () => cogoToast.success(`Copied ${text}`),
    () => cogoToast.error("Couldn't copy — select the code and copy it manually.")
  );
};
